import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CircularProgress } from '@material-ui/core';
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { getPartner, hasAuthourity } from '../../../../../lib/access.es6';
import Tooltip from '@mui/material/Tooltip';
import { ClaimTypeEnum } from '../../../lib/enum';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import find from 'lodash/find';

const LegalExpenses = (props) => {
  console.log("legal expenses props", props)
  const classes = useStyle();
  const currencyCode = getPartner().country.currency_code
  const claimGuid = props.claimExpense.guid
  const [invoiceToPay, setInvoiceToPay] = useState(null)

  const handleConfirmMarkAsPaid = () => {
    props.markInvoiceAsPaid({
      claim_guid: claimGuid,
      benefit_usage_guid: invoiceToPay.guid,
    })
    setInvoiceToPay(null)
  }

  const handleMarkAsPaidSuccess = () => {
    props.resetMarkInvoiceAsPaidSuccessAlert()
    window.location.reload()
  }

  const benefits = props.claimExpense.benefits || [];
  const relevantBenefit = find(benefits, { type: props.type }) || (benefits.length > 0 ? benefits[0] : null);
  const totalBenefitLimitInCents = relevantBenefit && relevantBenefit.max_benefit_amount_in_cents ? relevantBenefit.max_benefit_amount_in_cents : 0;
  const totalSpentInCents = props.claimExpense.benefit_usages.reduce(function(psum, expense) { return psum + expense.benefit_amount_in_cents; }, 0);
  const balanceInCents = totalBenefitLimitInCents - totalSpentInCents ;

  const tempArr = props.claimExpense.benefit_usages.map(benefit => {
    return {
      ...benefit,
      invoice_amount_in_cents:   props.type === ClaimTypeEnum.death ?  `${currencyCode} ${(benefit.benefit_amount_in_cents).toLocaleString()  }`: `${benefit.invoice_number}` ? `${benefit.invoice_number}` : "N/A",
      benefit_amount_in_cents: benefit.benefit_amount_in_cents ? `${currencyCode}  ${(benefit.benefit_amount_in_cents / 100).toLocaleString()}` : "N/A",
      benefit_type: benefit.benefit_type ? benefit.benefit_type : "N/A",
      invoice_number: props.type === ClaimTypeEnum.death ? benefit.external_unique_identifier : benefit.invoice_number ? benefit.invoice_number : "N/A",
      created_at: benefit.created_at ? formatDateLocale(benefit.created_at) : "N/A",
    }
  })

  const tableData = tempArr;

  console.log("benefit usage", tempArr)
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}  >
          <Grid container spacing={2} className={classes.claimdocswrapper}>
            <Grid item xs={12} sm={12} md={12}>
              <TableInc
                columns={[
                  // {
                  //   title:  'Invoice Amount', field: 'invoice_amount_in_cents'
                  // },
                  {
                    title: 'Amount Payable', field: 'benefit_amount_in_cents'
                  },
                  {
                    title: 'Expense Type', field: 'benefit_type'
                  },
            
                  {
                    title:  'Invoice Number', field: 'invoice_number'
                  },
                  { title: 'Created At', field: 'created_at' },
                  { title: 'Status', field: 'status', render: rowData => {
                    const isPaid = rowData.marked_as_paid_date;
                    let invoiceStatus = '';

                    if (isPaid) {
                      invoiceStatus = 'Paid';
                    } else {
                      invoiceStatus = 'Pending Payment';
                    }

                    return <>{invoiceStatus}</>;
                  } },

                  {
                    title: 'Action', field: 'action', render: rowData => {
                      return <div className={classes.actionbtn}>
                        {!rowData.marked_as_paid_date && <Tooltip title="Delete Claim Expense">
                          <span
                            style={{
                              cursor: "pointer",
                              display: hasAuthourity('UPDATE_CLAIM') ? 'inline' : 'none'
                            }}
                            onClick={() => props.setClaimExpenseToDelete(rowData)}
                          >
                            <DeleteIcon sx={{ color: "#8F191C" }} />
                          </span>
                        </Tooltip>
                    }
                        {
                          !rowData.marked_as_paid_date && (
                            <Tooltip title="Mark Invoice as Paid">
                              <span
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                  display: hasAuthourity('UPDATE_CLAIM') ? 'inline' : 'none'
                                }}
                                onClick={() => setInvoiceToPay(rowData)}
                              >
                                <CheckCircleIcon sx={{ color: "#4CAF50" }} />
                              </span>
                            </Tooltip>
                          )
                        }
                      </div>
                    }
                  },
                ]}
                data={tableData}
                options={{
                  pageSize: tempArr.length < 5
                    ? tempArr.length
                    : 5,
                    showTitle: false,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.totalExpense}>
            <p><strong>Total Claim Expense</strong>: {currencyCode + " " + (totalSpentInCents / 100).toLocaleString()}</p>
            <p><strong>Balance</strong>: {currencyCode + " " + (balanceInCents/100).toLocaleString()}</p>
          </div>
        </Grid>
      </Grid>
      <AlertDialog
        warning
        show={!!invoiceToPay}
        size="sm"
        title="Mark Invoice as Paid"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => setInvoiceToPay(null)}
        onCancel={() => handleConfirmMarkAsPaid()}
        confirmBtnText="Cancel"
        cancelBtnText="Mark as Paid"
        showCancel={true}
        showConfirm={true}
        confirmBtnCssClass
      >
        Are you sure you want to mark this invoice as paid?
        This action cannot be undone.
      </AlertDialog>

      <AlertDialog
        custom
        show={props.showMarkInvoiceAsPaidProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        showCancel={false}
        showConfirm={false}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Marking Invoice as Paid...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showMarkInvoiceAsPaidSuccessAlert}
        size="sm"
        title="Invoice Marked as Paid"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={handleMarkAsPaidSuccess}
        confirmBtnText="OK"
        showCancel={false}
        showConfirm={true}
        confirmBtnCssClass
      >
      </AlertDialog>

      <AlertDialog
        danger
        show={props.showMarkInvoiceAsPaidErrorAlert}
        size="sm"
        title="Error Marking Invoice as Paid"
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={props.resetMarkInvoiceAsPaidErrorAlert}
        confirmBtnText="Try Again"
        showCancel={false}
        confirmBtnCssClass
      >
        {
          props.markInvoiceAsPaidError
            ? JSON.stringify(props.markInvoiceAsPaidError)
            : 'Could not mark invoice as paid.'
        }
      </AlertDialog>
    </>
  )
}

export default LegalExpenses